import { FulfilmentPath } from './tiAttributes';
import { tr } from './translations/tr';

type StaticText = Record<string, string>;

/**
 * Supporting wording under the CTA, resolved brand → locale → path (CMS-1643).
 * The brand name is baked into the e2e string and the brand/locale variant is
 * resolved through `staticText` (base = SingSaver, `moneyhero.ts` overrides), so
 * this only branches on the path. An absent / unrecognised path yields
 * `undefined` (no wording, CTA still works — CMS-1643 AC-16).
 */
export function resolveTiSupportingWording(params: {
  staticText: StaticText;
  fulfilmentPath?: FulfilmentPath;
  providerName?: string;
}): string | undefined {
  const { staticText, fulfilmentPath, providerName } = params;

  if (fulfilmentPath === 'e2e') {
    return tr('ti_supporting_e2e', staticText);
  }
  if (fulfilmentPath === 'click_out') {
    // Without a provider name the interpolated copy breaks ("redirected to 's
    // official site"), so omit the supporting wording (CTA still works).
    const trimmedProviderName = providerName?.trim();
    if (!trimmedProviderName) return undefined;
    return tr('ti_supporting_click_out', staticText, {
      'provider-name': trimmedProviderName,
    });
  }
  return undefined;
}

/**
 * Footer heading `apply_for` ("Apply for :product-name") with the tier name as
 * the product (CMS-1643). Falls back to the generic apply label when the tier
 * name is missing/blank, so the heading never renders a dangling "Apply for "
 * (defensive: the footer only mounts once a named tier is active).
 */
export function resolveTiFooterCopy(params: {
  staticText: StaticText;
  tierName?: string;
}): string {
  const tierName = params.tierName?.trim();
  if (!tierName) return tr('ti_apply_now', params.staticText);
  return tr('apply_for', params.staticText, {
    'product-name': tierName,
  });
}
